module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/erro_reputacion.86eecb96.svg";